import { useAppSelector } from "./useReduxHooks";
import { useEffect, useState } from "react";
import { AnalysisData } from "../types/companyTypes";

export const useGetStatusFromSSE = (campaign_id: string) => {
  const [currentAnalysis, setCurrentAnalysis] = useState<
    AnalysisData | undefined
  >(undefined);

  const [currentScraping, setCurrentScraping] = useState<
    AnalysisData | undefined
  >(undefined);

  const { analysis_status, scraping_status, scraping_update_status } =
    useAppSelector((state) => state.company.status);

  useEffect(() => {
    if (analysis_status?.campaign_id === campaign_id)
      setCurrentAnalysis(analysis_status);
  }, [analysis_status]);

  useEffect(() => {
    if (scraping_status?.campaign_id === campaign_id)
      setCurrentScraping(scraping_status);
  }, [scraping_status]);

  useEffect(() => {
    if (scraping_update_status?.campaign_id === campaign_id)
      setCurrentScraping(scraping_update_status);
  }, [scraping_update_status]);

  return { analysis_status: currentAnalysis, scraping_status: currentScraping };
};
